import React from 'react'
import { SearchInputLayout } from './SearchInputLayout'
import { SearchInputProvider } from './Context'

export const MongoSearchInput = () => {
  return (
    <SearchInputProvider>
      <SearchInputLayout />
    </SearchInputProvider>
  )
}
